import styles from "./style.module.scss";

import DynamicForm from "@mavichpe/dynamic-forms";
import { DocumentPlazoChangeDataType } from "@/formTypes/DocumentPlazoChangeDataType";
import ChangeDocumentPlazoFormConfig from "./form";

type ChangeDocumentPlazoFormProps = {
  onPlazoChanged: (data: DocumentPlazoChangeDataType) => void,
  defaultData: DocumentPlazoChangeDataType,
  innerForm?: boolean
}

const ChangeDocumentPlazoForm = (props: ChangeDocumentPlazoFormProps) => {
  const { onPlazoChanged, innerForm = false, defaultData } = props;

  const onSubmit = (formData: DocumentPlazoChangeDataType) => {
    if (onPlazoChanged) {
      onPlazoChanged(formData)
    }
  }

  return (
    <>
      <DynamicForm<DocumentPlazoChangeDataType>
        externalFormState={defaultData}
        innerForm={innerForm}
        formConfig={ChangeDocumentPlazoFormConfig}
        onSubmit={onSubmit}
      >
      </DynamicForm>
    </>

  )
}

export default ChangeDocumentPlazoForm;